import React from "react";
import bgImage from "./assets/aboutus/aboutushero.jpg"; // Replace with correct path

const AboutHero = () => {
  return (
    <section
      className="relative h-screen bg-cover bg-center flex items-center justify-center text-white text-center px-6 md:px-12"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      {/* Animations CSS */}
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(30px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes slideDown {
            0% { opacity: 0; transform: translateY(-20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @keyframes popRotateLeft {
            0% { opacity: 0; transform: scale(0.5) rotate(0deg); }
            100% { opacity: 1; transform: scale(1) rotate(-15deg); }
          }
          @keyframes popRotateRight {
            0% { opacity: 0; transform: scale(0.5) rotate(0deg); }
            100% { opacity: 1; transform: scale(1) rotate(15deg); }
          }
          .animate-fade-in {
            animation: fadeInUp 0.8s ease-out forwards;
          }
          .animate-blue-slide {
            animation: slideDown 0.8s ease-out 0.6s forwards;
          }
          .animate-pop-left {
            animation: popRotateLeft 0.6s ease-out 0.3s forwards;
          }
          .animate-pop-right {
            animation: popRotateRight 0.6s ease-out 0.5s forwards;
          }
        `}
      </style>

      {/* Overlay */}
      <div
        className="absolute top-0 left-0 w-full h-full z-[2] pointer-events-none"
        style={{
          background: `linear-gradient(
            to bottom,
            rgba(2, 4, 79, 0.85) 0%,
            rgba(2, 4, 79, 0.65) 25%,
            rgba(134, 205, 233, 0.85) 90%,
            rgba(134, 205, 233, 1) 100%
          )`
        }}
      />

      {/* Main Content */}
      <div className="relative z-10 max-w-4xl opacity-0 animate-fade-in">
        <h1 className="text-white text-[50px] md:text-[70px] font-bold leading-tight">
          Who We Are Behind The <br />
          <span className="text-[#00B2FF]">Movement</span>
        </h1>

        <p className="text-white sm:text-[16px] md:text-[18px] lg:text-[20px] font-light mt-4 leading-relaxed">
          Big Blue was built to solve what others complicate. We turn logistics into momentum by combining <br />
          sharp systems, real people and routes that connect continents. From first-time shippers to <br />
          global supply chains, businesses trust us to move what matters without losing control.
        </p>
      </div>

      {/* Bottom Text Row */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex items-end justify-center gap-0 z-10">
        <div className="whitespace-nowrap opacity-0 bg-[#00B2FF] text-white text-[22px] md:text-[30px] font-bold py-1 px-5 md:px-6 rounded-2xl mb-6 animate-pop-left">
          THE BIG
        </div>
        <div className="opacity-0 text-white text-[36px] md:text-[42px] font-extrabold animate-blue-slide">
          BLUE
        </div>
        <div className="opacity-0 bg-[#001737] text-white text-[22px] md:text-[30px] font-bold py-1 px-5 md:px-6 rounded-2xl mb-6 animate-pop-right">
          BEGINNING
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
